import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { TFMark } from './TFLogo';

export default function LoginPage() {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" data-testid="login-page">
      <div className="w-full max-w-md">
        {/* Brand header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-6 mb-6">
            <TFMark color="#002FA7" size={36} />
            <span
              className="font-heading font-bold text-xl sm:text-2xl uppercase text-tf-primary"
              style={{ letterSpacing: '0.85em', paddingLeft: '0.85em' }}
            >
              TRUSTFRAME
            </span>
          </div>
          <p className="font-mono text-[11px] tracking-[0.2em] text-tf-text-2 uppercase">
            [ .secure. .art. .transactions. ]
          </p>
        </div>

        {/* Login card */}
        <div className="bg-tf-surface border border-tf-border p-8">
          <p className="font-mono text-[10px] tracking-[0.2em] text-tf-text-2 uppercase mb-6">
            [ .admin. .access. ]
          </p>

          <form onSubmit={handleSubmit}>
            <div className="mb-5">
              <label className="block font-body text-[10px] tracking-[0.25em] uppercase text-tf-text-2 mb-2 font-medium">
                Email
              </label>
              <input
                data-testid="login-email-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-3 border border-tf-border-light bg-tf-bg font-mono text-sm text-tf-text focus:outline-none focus:border-tf-primary transition-colors duration-200"
                placeholder="admin@trustframe.legal"
                required
              />
            </div>

            <div className="mb-6">
              <label className="block font-body text-[10px] tracking-[0.25em] uppercase text-tf-text-2 mb-2 font-medium">
                Password
              </label>
              <input
                data-testid="login-password-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-3 border border-tf-border-light bg-tf-bg font-mono text-sm text-tf-text focus:outline-none focus:border-tf-primary transition-colors duration-200"
                placeholder="Enter password"
                required
              />
            </div>

            {error && (
              <div
                data-testid="login-error"
                className="mb-5 px-4 py-3 border border-tf-danger bg-red-50 font-body text-sm text-tf-danger"
              >
                {error}
              </div>
            )}

            <button
              data-testid="login-submit-btn"
              type="submit"
              disabled={loading}
              className="w-full py-3 bg-tf-primary text-white font-heading text-xs tracking-[0.3em] uppercase hover:bg-tf-accent transition-all duration-300 disabled:opacity-50"
            >
              {loading ? 'Authenticating...' : 'Sign In'}
            </button>
          </form>
        </div>

        <p className="font-mono text-[10px] text-tf-text-3 mt-8 text-center tracking-[0.15em]">
          TrustFrame &middot; Secure Art Transactions Built on Trust
        </p>
      </div>
    </div>
  );
}
